module.exports = __webpack_public_path__ + "static/img_2058-6b4974f95633a4badc97b32d07d6c9fb.webp";